(function () {
  'use strict';

  // Only activate on the plate-insert product page
  if (!window.location.pathname.includes('number-plate-inserts-2026')) return;

  const SUGGESTED_HANDLE = '2026-mini-window-number-plate-decals';
  const MESSAGE = "Nice pick — grab matching window decals while you’re here!";
  const CTA = 'Shop Window Decals';
  const DISMISS_KEY = 'bmx-plate-upsell-dismissed';
  const OVERLAY_ID = 'bmx-upsell-overlay';

  // ─── Utilities ────────────────────────────────────────────────────────────

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  // ─── Modal ────────────────────────────────────────────────────────────────

  function showModal(product) {
    if (sessionStorage.getItem(DISMISS_KEY)) return;

    const variant = product.variants.find(v => v.available) || product.variants[0];
    const imageUrl = product.featured_image || '';

    const overlay = document.getElementById(OVERLAY_ID);
    overlay.querySelector('#bmx-upsell-img').src = imageUrl ? imageUrl + '&width=192' : '';
    overlay.querySelector('#bmx-upsell-img').alt = product.title;
    overlay.querySelector('#bmx-upsell-message').textContent = MESSAGE;
    overlay.querySelector('#bmx-upsell-title').textContent = product.title;
    overlay.querySelector('#bmx-upsell-price').textContent = formatMoney(variant.price);
    var linkBtn = overlay.querySelector('#bmx-upsell-link-btn');
    linkBtn.href = '/products/' + SUGGESTED_HANDLE;
    linkBtn.querySelector('#bmx-upsell-cta-link').textContent = CTA;
    linkBtn.hidden = false;
    overlay.querySelector('#bmx-upsell-add-btn').hidden = true;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function hideModal() {
    const overlay = document.getElementById(OVERLAY_ID);
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }

  // ─── Add to cart ──────────────────────────────────────────────────────────

  async function addToCart(variantId) {
    const btn = document.querySelector('#bmx-upsell-add-btn');
    btn.disabled = true;
    btn.querySelector('#bmx-upsell-cta-add').textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
      if (res.ok) {
        hideModal();
        sessionStorage.setItem(DISMISS_KEY, '1');
      } else {
        btn.disabled = false;
        btn.querySelector('#bmx-upsell-cta-add').textContent = 'Try again';
      }
    } catch {
      btn.disabled = false;
    }
  }

  // ─── Event wiring ─────────────────────────────────────────────────────────

  function dismiss() {
    sessionStorage.setItem(DISMISS_KEY, '1');
    hideModal();
  }

  function wireModal() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('#bmx-upsell-add-btn')) {
        const btn = e.target.closest('#bmx-upsell-add-btn');
        if (btn.dataset.variantId) addToCart(btn.dataset.variantId);
      }
      if (e.target.closest('#bmx-upsell-dismiss-btn') || e.target.closest('#bmx-upsell-no-thanks')) {
        dismiss();
      }
      if (e.target.id === OVERLAY_ID) dismiss();
    });
  }

  // Intercept ATC on THIS page only — only fires when the user clicks the button
  function wireAddToCart() {
    var userInitiated = false;

    // Mark intent when the customer clicks the ATC button or submits the form
    var atcForm = document.querySelector('form[action="/cart/add"]');
    if (atcForm) {
      atcForm.addEventListener('submit', function () { userInitiated = true; });
    }

    if (typeof jQuery === 'undefined') return;

    jQuery(document).ajaxSuccess(function (event, xhr, settings) {
      if (!userInitiated) return;
      if (settings.url && settings.url.includes('/cart/add')) {
        userInitiated = false;
        fetch('/products/' + SUGGESTED_HANDLE + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) { if (product) showModal(product); })
          .catch(function () {});
      }
    });
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  function init() {
    wireModal();
    wireAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
